const LEVEL_DEBUG = 0;
const LEVEL_INFO = 1;
const LEVEL_WARN = 2;
const LEVEL_ERROR = 3;

const LEVELS = ['debug', 'info', 'warn', 'error'];

let defaultLevel = window.IS_PRODUCTION ? LEVEL_WARN : LEVEL_DEBUG;

/**
 * Creates new logger instance with default level.
 * @param {string|null} name
 * @return {MyLogger}
 */
export function newLogger(name = null) {
	return new MyLogger(name, defaultLevel);
}

/**
 * Sets level for new loggers.
 * @param {number} level
 */
export function setDefaultLevel(level) {
	defaultLevel = level;
}

class MyLogger {
	_name = '';
	_level = -1;
	_dummy = () => {
	};

	constructor(name, level) {
		this._name = name;
		this.setLevel(level);
	}

	setLevel(level) {
		level = Number.isInteger(level) ? level : LEVELS.indexOf(level);
		this._level = level;

		const name = this._name ? '[' + this._name + ']' : null;
		const bind = (condition, methodName) => {
			if (!condition || !console[methodName]) return this._dummy;
			return name ? console[methodName].bind(console, name) : console[methodName].bind(console);
		};
		const bindSimple = (condition, methodName) => {
			return condition && console[methodName] ? console[methodName].bind(console) : this._dummy;
		};

		[
			['log', LEVEL_DEBUG],
			['info', LEVEL_INFO],
			['warn', LEVEL_WARN],
			['error', LEVEL_ERROR],
		].forEach(i => {
			const [method, lvl] = i;
			this[method] = bind(level <= lvl, method);
		});

		[
			'time',
			'timeEnd',
			'profile',
			'profileEnd',
		].forEach(method => {
			this[method] = bindSimple(level <= LEVEL_DEBUG, method);
		});
	}

	/** The same as {@link Console.log} */
	log(args) {
	}

	/** The same as {@link Console.info} */
	info(args) {
	}

	/** The same as {@link Console.warn} */
	warn(args) {
	}

	/** The same as {@link Console.error} */
	error(args) {
	}

	/** The same as {@link Console.time} */
	time(label) {
	}

	/** The same as {@link Console.timeEnd} */
	timeEnd(label) {
	}

	/** The same as {@link Console.profile} */
	profile(label) {
	}

	/** The same as {@link Console.profileEnd} */
	profileEnd(label) {
	}

	measureTime(label, callable) {
		this.time(label);
		const result = callable();
		this.timeEnd(label);
		return result;
	}

	doProfile(label, callable) {
		this.profile(label);
		const result = callable();
		this.profileEnd(label);
		return result;
	}

	setLevelDebug() {
		this.setLevel(LEVEL_DEBUG);
	}

	setLevelInfo() {
		this.setLevel(LEVEL_INFO);
	}

	setLevelWarn() {
		this.setLevel(LEVEL_WARN);
	}

	setLevelError() {
		this.setLevel(LEVEL_ERROR);
	}
}

export default newLogger();



// WEBPACK FOOTER //
// ./core/utils/logger.js